import { Permission } from "./permission.model";

export class PermissionGroup {
    title!: string;
    icon?: string;
    url!: string;
    showDivider!: boolean;
    permissions?: Permission[];
    groups?: PermissionGroup[];
    active!: boolean;
    showMenu!: boolean;
    code!: string;
}